import Cookies, { CookieAttributes } from 'js-cookie'
import { getConfig } from '@services/context'
import { STORAGE_KEY } from '../constants'
import { getHost } from '../helpers'

export const get = <T>(key, defaultValue: Nullable<T> = null): Nullable<T> => {
  const state = getState()[key]

  if (state === null) {
    return defaultValue
  }

  return state
}

export const set = (key, value, options: CookieAttributes = {}): any => {
  const state = getState()
  const defaultOptions = getSetOptions({
    secure: PRODUCTION
  })

  state[key] = value

  return Cookies.set(getCookieKey(), JSON.stringify(state), {
    ...defaultOptions,
    ...options
  })
}

export const remove = (key: string): void => {
  const state = Cookies.get(getCookieKey())

  if (!state) {
    return
  }

  const object = JSON.parse(state)

  if (object.hasOwnProperty(key)) {
    delete object[key]

    Cookies.set(
      getCookieKey(),
      JSON.stringify(object),
      getSetOptions({
        secure: PRODUCTION
      })
    )
  }
}

const getState = (): any => {
  const state = Cookies.get(getCookieKey())

  if (!state) {
    return {}
  }

  return JSON.parse(state)
}

const getCookieKey = (): string => {
  return `${STORAGE_KEY}_${getConfig('clientKey')}`
}

const getSetOptions = (options: CookieAttributes): CookieAttributes => {
  return {
    domain: getHost(),
    expires: 365,
    sameSite: PRODUCTION ? 'None' : 'Lax',
    ...options
  }
}
